Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;
    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
    };

    self.$onInit = () => {
        self.dateFormat = self.dateFormat || 'MMM, yyyy';
    }

    self.handleBlur = () => {
        if (!self.ngModel) {
            self.showLegend = false;
        }
        self.inputFocused = false;

        if (self.blurEvent) {
            self.blurEvent();
        }
    };

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        });
    };
}

export function HuiInputMonthPicker() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            onChange: '&',
            blurEvent: '&',
            fullWidth: '<',
            minDate: '<',
            maxDate: '<',
            dateFormat: '@',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon',
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                model-value="$huiCtrl.ngModel"
                disabled="$huiCtrl.disabled"
                full-width="$huiCtrl.fullWidth">
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                <hui-input-base-icon ng-transclude ng-transclude-slot="icon"></hui-input-base-icon>
                <input ng-model="$huiCtrl.ngModel"
                       class="hui-base-input month-datepicker"
                       type="text"
                       name="{{$huiCtrl.hName}}"
                       ng-change="$huiCtrl.handleChange($event)"
                       ng-focus="$huiCtrl.handleFocus()"
                       ng-blur="$huiCtrl.handleBlur()"
                       ng-disabled="$huiCtrl.disabled"
                       min-view="1"
                       ng-change="$huiCtrl.onFiltersChanged()"
                       min-date="{{$huiCtrl.minDate}}"
                       max-date="{{$huiCtrl.maxDate}}"
                       date-format="{{$huiCtrl.dateFormat}}" bs-datepicker>
              </hui-input-base>
             `;
        }
    }
}

